import React from 'react';
import styles from '../styles/Support.module.css';

const statusColors = {
  Open: styles.openBadge,
  'In Progress': styles.progressBadge,
  Resolved: styles.resolvedBadge,
};

const SupportTicketCard = ({ ticket, onView, onResolve, onDelete }) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <span className={styles.ticketId}>#{ticket.id}</span>
      <span className={statusColors[ticket.status] || styles.openBadge}>{ticket.status}</span>
    </div>
    <div className={styles.cardBody}>
      <div className={styles.customerInfo}>
        <span className={styles.customerName}>{ticket.customer}</span>
        <span className={styles.email}>{ticket.email}</span>
      </div>
      <div className={styles.subject}>{ticket.subject}</div>
      <div className={styles.messagePreview}>{ticket.message.slice(0, 60)}{ticket.message.length > 60 ? '...' : ''}</div>
      <div className={styles.date}>{ticket.date}</div>
    </div>
    <div className={styles.cardActions}>
      <button className={styles.viewBtn} onClick={() => onView(ticket)} title="View"><span role="img" aria-label="view">👁️</span></button>
      {ticket.status !== 'Resolved' && (
        <button className={styles.resolveBtn} onClick={() => onResolve(ticket.id)} title="Mark as Resolved"><span role="img" aria-label="resolve">✅</span></button>
      )}
      <button className={styles.deleteBtn} onClick={() => onDelete(ticket.id)} title="Delete"><span role="img" aria-label="delete">🗑️</span></button>
    </div>
  </div>
);

export default SupportTicketCard;
